export default {
    "Apto 57.98 m²": "https://umbra3d.studio/recorridos/prodesa/capriella-58/",
    "Apto 68.7 m²": "https://umbra3d.studio/recorridos/prodesa/capriella-58/",
    "Apto 87.46 m²": "https://umbra3d.studio/recorridos/prodesa/capriella-72/",
    "Apto 72.51 m²": "https://umbra3d.studio/recorridos/prodesa/capriella-72/",
}